import React from 'react';
import { Card, Select, Typography, Button } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import FormField from './FormField';
import { useTranslation } from 'react-i18next';

const { Text } = Typography;

export default function FormCol({ colData, onUpdate, onDelete }) {
  const { t } = useTranslation();

  const handleFieldChange = (key, value) => {
    onUpdate({
      ...colData,
      field: { ...colData.field, [key]: value }
    });
  };

  return (
    <Card
      title={t('formBuilder.field')}
      size="small"
      style={{ background: '#fcfcfc', borderStyle: 'dashed', borderRadius: '4px' }}
      extra={
        <Button
          type="text"
          danger
          size="small"
          icon={<DeleteOutlined style={{ fontSize: '12px' }} />}
          onClick={onDelete}
          style={{ fontSize: '12px' }}
        >{t('formBuilder.deleteField')}</Button>
      }
    >
      <FormField fieldData={colData.field} onChange={handleFieldChange} />
      <Text type="secondary" strong style={{ fontSize: '11px' }}>{t('formBuilder.width')}</Text>
      <Select
        value={colData.width}
        size="small"
        style={{ width: '100%', marginBottom: 12, marginTop: 4 }}
        onChange={(val) => onUpdate({ ...colData, width: val })}
        options={[
          { value: '1/4', label: '1/4' },
          { value: '1/3', label: '1/3' },
          { value: '1/2', label: '1/2' },
          { value: '1', label: t('formBuilder.full') },
        ]}
      />
    </Card>
  );
}